import React from "react";
import styled from "styled-components";
import LoadingSpinner from "../LoadingSpinner/loading-spinner.component";

const ModalContainer = styled.div`
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	display: ${(props) => (props.show ? "flex" : "none")};
	justify-content: center;
	align-items: center;
	z-index: 9999;
`;

const ModalContent = styled.div`
	background-color: #fff;
	padding: 2rem;
	border-radius: 8px;
	width: 400px;
	text-align: center;
`;

const Button = styled.button`
	padding: 0.5rem 1rem;
	background-color: #007bff;
	color: white;
	border: none;
	border-radius: 0.25rem;
	cursor: pointer;
	margin: 1rem 0;
	&:disabled {
		background-color: #6c757d;
	}
`;

const MessageSendingProgressModal = ({
	isOpen,
	currentBatch,
	totalBatches,
	errorMessage,
	onClose,
}) => {
	const hasBatches = totalBatches && totalBatches > 0;
	const showSpinner = !errorMessage;
	const percentage =
		hasBatches && totalBatches > 0
			? Math.round((currentBatch / totalBatches) * 100)
			: 0;

	return (
		<ModalContainer show={isOpen}>
			<ModalContent>
				<h3>Please wait</h3>
				<p>Sending messages in batches. Do not close this window.</p>
				{hasBatches && (
					<>
						<p>
							Batch {Math.min(currentBatch, totalBatches)} of{" "}
							{totalBatches}
						</p>
						<progress
							value={currentBatch}
							max={totalBatches}
							style={{ width: "100%" }}
						/>
						<p style={{ marginTop: "0.5rem", fontSize: "0.9rem" }}>
							{percentage}% complete
						</p>
					</>
				)}
				{showSpinner && (
					<div
						style={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							height: "100%",
							padding: 15,
						}}
					>
						<LoadingSpinner />
					</div>
				)}
				{errorMessage && (
					<p style={{ color: "red", marginTop: "1rem" }}>
						{errorMessage}
					</p>
				)}
				<Button onClick={onClose} disabled={showSpinner}>
					Close
				</Button>
			</ModalContent>
		</ModalContainer>
	);
};

export default MessageSendingProgressModal;

